import React from 'react';
import CollectionPage from '../shared/CollectionPage';

/**
 * Console Collection Page component
 * Uses the generic CollectionPage with console-specific configuration
 */
const ConsoleCollectionPage = () => {
  // Console-specific filter options
  const consoleFilterOptions = [
    { value: '', label: 'All Generations' },
    { value: '1', label: '1st Generation' },
    { value: '2', label: '2nd Generation' },
    { value: '3', label: '3rd Generation' },
    { value: '4', label: '4th Generation' },
    { value: '5', label: '5th Generation' },
    { value: '6', label: '6th Generation' },
    { value: '7', label: '7th Generation' },
    { value: '8', label: '8th Generation' },
    { value: '9', label: '9th Generation' },
  ];

  // Console-specific render props
  const consoleRenderProps = {
    getImageUrl: (item) => item.imageUrl || item.processedImageUrl || item.platformLogo,
    getItemSubtitle: (item) => `Generation: ${item.generation || 'N/A'} • Condition: ${item.condition || 'N/A'}`,
    getItemDetails: (item) => item.alternative_name ? `Alternative Name: ${item.alternative_name}` : null
  };

  // Console-specific filter function
  const getConsoleFilterValue = (item) => item.generation;

  // Console-specific edit fields
  const consoleEditFields = [
    {
      name: 'name',
      label: 'Name',
      type: 'text',
      required: true,
      gridProps: { xs: 12 }
    },
    {
      name: 'generation',
      label: 'Generation',
      type: 'select',
      options: ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
      required: false,
      gridProps: { xs: 12, sm: 6 }
    },
    {
      name: 'condition',
      label: 'Condition',
      type: 'select',
      options: ['Poor', 'Fair', 'Good', 'Very Good', 'Excellent', 'Mint'],
      required: false,
      gridProps: { xs: 12, sm: 6 }
    },
    {
      name: 'alternative_name',
      label: 'Alternative Name',
      type: 'text',
      required: false,
      gridProps: { xs: 12 }
    },
    {
      name: 'imageUrl',
      label: 'Image URL',
      type: 'text',
      required: false,
      gridProps: { xs: 12, sm: 6 }
    },
    {
      name: 'platformLogo',
      label: 'Platform Logo URL',
      type: 'text',
      required: false,
      gridProps: { xs: 12, sm: 6 }
    },
    {
      name: 'version',
      label: 'Version',
      type: 'text',
      required: false,
      gridProps: { xs: 12, sm: 6 }
    },
    {
      name: 'manufacturer',
      label: 'Manufacturer',
      type: 'text',
      required: false,
      gridProps: { xs: 12, sm: 6 }
    },

    {
      name: 'description',
      label: 'Description',
      type: 'text',
      multiline: true,
      rows: 3,
      required: false,
      gridProps: { xs: 12 }
    },
    {
      name: 'summary',
      label: 'Summary',
      type: 'text',
      multiline: true,
      rows: 2,
      required: false,
      gridProps: { xs: 12 }
    },
    {
      name: 'rating',
      label: 'Rating',
      type: 'rating',
      required: false,
      gridProps: { xs: 12 }
    },
    {
      name: 'notes',
      label: 'Notes',
      type: 'text',
      multiline: true,
      rows: 4,
      required: false,
      gridProps: { xs: 12 }
    }
  ];

  return (
    <CollectionPage
      collectionType="consoles"
      title="Console Collection"
      renderProps={consoleRenderProps}
      filterOptions={consoleFilterOptions}
      getFilterValue={getConsoleFilterValue}
      editFields={consoleEditFields}
      itemType="console"
    />
  );
};

export default ConsoleCollectionPage;
